import { DateHelper } from '../util/dateHelper';
import { Deserializable } from './deserializable';

export class DevicePilomatIO implements Deserializable {

  number: number;
  serial: string;
  type: string;
  typeString: string;
  mode: string;
  name: string;
  lastActiveState: boolean;
  lastActiveStateDate: string;
  typeListObject : any;

  static EVENT_TYPE_SIGNAL_LOWERED_SWITCH: string = "inp-ls";
  static EVENT_TYPE_SIGNAL_LIFTED_UP_SWITCH: string = "inp-lus";
  static EVENT_TYPE_SIGNAL_LIFTED_UP_PRESSURE: string = "inp-lup";
  static EVENT_TYPE_SIGNAL_CRASH_SENSOR: string = "inp-cs";
  static EVENT_TYPE_SIGNAL_GLASS_BREAKAGE: string = "inp-gb";
  static EVENT_TYPE_SIGNAL_EFO: string = "inp-efo";
  static EVENT_TYPE_SIGNAL_START: string = "inp-start";
  static EVENT_TYPE_SIGNAL_PRESSURE_LOW: string = "inp-plow";
  static EVENT_TYPE_SIGNAL_SAFETY: string = "inp-safe";
  static EVENT_TYPE_SIGNAL_OTHER: string = "inp-other";
  static EVENT_TYPE_ERROR_PRESSURE_LOW: string = "err-pressure-low";
  static EVENT_TYPE_ERROR_SAFETY: string = "err-safety";
  static EVENT_TYPE_ERROR_GLASS_BREAKAGE: string = "err-glass-breakage";

  // if versione >=100
  static EVENT_TYPE_SIGNAL_DOOR_OPEN: string = "inp-door";
  static EVENT_TYPE_SIGNAL_KEY_LOCKDOWN: string = "inp-keyd";
  static EVENT_TYPE_SIGNAL_KEY_LOCKUP: string = "inp-keyu";
  static EVENT_TYPE_SIGNAL_POWER_SUPPLY: string = "inp-power";
  static EVENT_TYPE_SIGNAL_UPS: string = "inp-ups";
  static INPUT_TYPE_SIGNAL_PUMP_ALARM: string = "inp-alpump";


  static EVENT_TYPE_SIGNAL_LOWERED_SWITCH_STRING: string = $localize`:@@device_pilomat_io_model_lower_switch:Switch contatto basso`;
  static EVENT_TYPE_SIGNAL_LIFTED_UP_SWITCH_STRING: string = $localize`:@@device_pilomat_io_model_upper_switch:Switch contatto alto`;
  static EVENT_TYPE_SIGNAL_LIFTED_UP_PRESSURE_STRING: string = $localize`:@@device_pilomat_io_model_upper_pressure_switch:Switch alto da pressione`;
  static EVENT_TYPE_SIGNAL_CRASH_SENSOR_STRING: string = $localize`:@@device_pilomat_io_model_crash_sensor:Crash sensor`;
  static EVENT_TYPE_SIGNAL_GLASS_BREAKAGE_STRING: string = $localize`:@@device_pilomat_io_model_glass_breakage:Glass breakage`;
  static EVENT_TYPE_SIGNAL_EFO_STRING: string = $localize`:@@device_pilomat_io_model_efo:EFO`;
  static EVENT_TYPE_SIGNAL_START_STRING: string = $localize`:@@device_pilomat_io_model_start:Start`;
  static EVENT_TYPE_SIGNAL_PRESSURE_LOW_STRING: string = $localize`:@@device_pilomat_io_model_low_pressure:Bassa pressione`
  static EVENT_TYPE_SIGNAL_SAFETY_STRING: string = $localize`:@@device_pilomat_io_model_safety:Contatto safety`;
  static EVENT_TYPE_SIGNAL_OTHER_STRING: string = $localize`:@@device_pilomat_io_model_other:Altro`;
  static EVENT_TYPE_ERROR_PRESSURE_LOW_STRING: string = $localize`:@@device_pilomat_io_model_low_pressure_error:Errore bassa pressione`; 
  static EVENT_TYPE_ERROR_SAFETY_STRING: string = $localize`:@@device_pilomat_io_model_error_safety:Errore safety`;
  static EVENT_TYPE_ERROR_GLASS_BREAKAGE_STRING: string = $localize`:@@device_pilomat_io_model_error_glass_breakage:Errore glass breakage`;
  static INPUT_TYPE_SIGNAL_PUMP_ALARM_STRING: string = $localize`:@@device_pilomat_io_model_allarm_pump:Allarme pompa immersione`;

  // if versione >=100
  static EVENT_TYPE_SIGNAL_DOOR_OPEN_STRING: string = $localize`:@@device_pilomat_io_model_door_open:Sensore apertura sportello`;
  static EVENT_TYPE_SIGNAL_KEY_LOCKDOWN_STRING: string = $localize`:@@device_pilomat_io_model_key_lockdown:Sensore chiave forzato basso`;
  static EVENT_TYPE_SIGNAL_KEY_LOCKUP_STRING: string = $localize`:@@device_pilomat_io_model_key_lockup:Sensore chiave forzato alto`;
  static EVENT_TYPE_SIGNAL_POWER_SUPPLY_STRING: string = $localize`:@@device_pilomat_io_model_power_supply:Sensore alimentatore`;
  static EVENT_TYPE_SIGNAL_UPS_STRING: string = $localize`:@@device_pilomat_io_model_ups:Sensore UPS`;

  static EVENT_MODE_NORMALLY_OPEN: string = "NO";
  static EVENT_MODE_NORMALLY_CLOSED: string = "NC";
  static EVENT_MODE_BUS: string = "BUS";

  static TYPES: Array<any> = [
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_LOWERED_SWITCH, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_LOWERED_SWITCH_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_LIFTED_UP_SWITCH, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_LIFTED_UP_SWITCH_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_LIFTED_UP_PRESSURE, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_LIFTED_UP_PRESSURE_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_CRASH_SENSOR, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_CRASH_SENSOR_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_GLASS_BREAKAGE, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_GLASS_BREAKAGE_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_EFO, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_EFO_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_START, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_START_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_PRESSURE_LOW, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_PRESSURE_LOW_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_SAFETY, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_SAFETY_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_OTHER, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_OTHER_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_ERROR_PRESSURE_LOW, text: DevicePilomatIO.EVENT_TYPE_ERROR_PRESSURE_LOW_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_ERROR_SAFETY, text: DevicePilomatIO.EVENT_TYPE_ERROR_SAFETY_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_ERROR_GLASS_BREAKAGE, text: DevicePilomatIO.EVENT_TYPE_ERROR_GLASS_BREAKAGE_STRING }
  ];

  static TYPES_NEW: Array<any> = [
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_LOWERED_SWITCH, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_LOWERED_SWITCH_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_LIFTED_UP_SWITCH, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_LIFTED_UP_SWITCH_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_LIFTED_UP_PRESSURE, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_LIFTED_UP_PRESSURE_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_CRASH_SENSOR, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_CRASH_SENSOR_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_GLASS_BREAKAGE, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_GLASS_BREAKAGE_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_EFO, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_EFO_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_START, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_START_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_PRESSURE_LOW, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_PRESSURE_LOW_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_SAFETY, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_SAFETY_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_OTHER, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_OTHER_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_ERROR_PRESSURE_LOW, text: DevicePilomatIO.EVENT_TYPE_ERROR_PRESSURE_LOW_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_ERROR_SAFETY, text: DevicePilomatIO.EVENT_TYPE_ERROR_SAFETY_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_ERROR_GLASS_BREAKAGE, text: DevicePilomatIO.EVENT_TYPE_ERROR_GLASS_BREAKAGE_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_DOOR_OPEN, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_DOOR_OPEN_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_KEY_LOCKDOWN, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_KEY_LOCKDOWN_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_KEY_LOCKUP, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_KEY_LOCKUP_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_POWER_SUPPLY, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_POWER_SUPPLY_STRING },
    { value: DevicePilomatIO.EVENT_TYPE_SIGNAL_UPS, text: DevicePilomatIO.EVENT_TYPE_SIGNAL_UPS_STRING },
    { value: DevicePilomatIO.INPUT_TYPE_SIGNAL_PUMP_ALARM, text: DevicePilomatIO.INPUT_TYPE_SIGNAL_PUMP_ALARM_STRING }

  ];

  static MODES: string[] = [
    DevicePilomatIO.EVENT_MODE_NORMALLY_OPEN,
    DevicePilomatIO.EVENT_MODE_NORMALLY_CLOSED,
    DevicePilomatIO.EVENT_MODE_BUS
  ];

  deserialize(input: any) {
    Object.assign(this, input);

    if (this.type) {
      for (let i = 0; i < DevicePilomatIO.TYPES_NEW.length; i++) {
        if (this.type == DevicePilomatIO.TYPES_NEW[i].value) {
          this.typeString = DevicePilomatIO.TYPES_NEW[i].text;
          this.typeListObject = DevicePilomatIO.TYPES_NEW[i];
        }
      }
    }
    return this;
  }

  isError(): boolean {

    return this.type.startsWith("err-");
  }

  getLastActiveStateDateFriendly() {

    return DateHelper.formatDateTimeFriendly(DateHelper.parseDate(this.lastActiveStateDate));
  }

}
